import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useField } from '@unform/core';

import { Box } from '../../styles/components/box';
import { Input as BaseInput } from './styles';

import { FormInputProps } from '~/types/main';

export function FormInput({
  name,
  title,
  disabled,
  validated = false,
  placeholder = "Digite aqui...",
  width = '14.8125rem',
  fullW = false,
  defaultValue: customDefaultValue,
  noTitle = false,
  style = {},
  inputStyle = {},
  onBlur = () => {},
  ...rest
}: FormInputProps) {
  const [isValidated, setIsValidated] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null)

  const { fieldName, defaultValue: formDefaultValue, registerField } = useField(name!)

  const defaultValue = useMemo(() => {
    const hasCustomDefaultValue = customDefaultValue !== undefined && customDefaultValue !== null;
    let currentValue = hasCustomDefaultValue ? customDefaultValue : formDefaultValue;

    if (currentValue === undefined || currentValue === null) {
      currentValue = '';
    }

    const normalized = String(currentValue).trim().toLowerCase();
    if (normalized === 'undefined' || normalized === 'null') {
      currentValue = '';
    }
    
    setIsValidated(!!currentValue);

    return currentValue;
  }, [customDefaultValue, formDefaultValue]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,

      getValue: ref => {
        return ref.current.value
      },

      setValue: (ref, value) => {
        ref.current.value = value ?? ''
      },

      clearValue: ref => {
        ref.current.value = ''
      },
    })
  }, [fieldName, registerField]);

  // Input não controlado: defaultValue do React não atualiza depois do mount. Quando o valor vindo do Unform/props muda (ex.: dados assíncronos), alinhar o DOM.
  useEffect(() => {
    if (!inputRef.current) return;
    inputRef.current.value = defaultValue;
  }, [defaultValue]);

  // @ts-ignore
  const handleOnBlur = useCallback((e) => {
    // @ts-ignore
    setIsValidated(!!e.target.value)
    // @ts-ignore
    onBlur(e);
  }, [onBlur]);

  return (
    <Box fullW={fullW} noTitle={noTitle} style={style}>
      {!noTitle && <label htmlFor={name}>{title}</label>}
      <BaseInput
        style={{overflow: 'auto', textAlign: 'left', ...inputStyle}}
        id={name}
        disabled={disabled}
        $validated={validated || !!isValidated}
        placeholder={placeholder}
        width={width}
        ref={inputRef}
        onBlur={handleOnBlur}
        defaultValue={defaultValue}
        isInput
        type={rest.type || "text"}
        {...rest}
      />
    </Box>
  );
}

